/*global window, _, MOVE_DATA, localStorage, JST */

import { isNull, isUndefined, isEmpty, negate, contains } from "underscore";
import "rdc-next-legacy-js-libs/js/jquery.mobile.js";
import { AB_SRP_LAYOUT_COOKIE_MAP, AB_SRP_LAYOUT_COOKIE_LIST, AB_SRP_LAYOUT_COOKIE_MIXED } from '../srp/basecamp/constants';

export const isBlank = (value) =>
  isNull(value) ||
  isUndefined(value) ||
  value === 0 ||
  isEmpty(value);

export const isPresent = negate(isBlank);

// Update the guid value returned from the lead service in the adobeDTM lead object.
// This is very important for omniture to track the number of leads
export const updateOmnitureLeadJson = function(leadData){
  MOVE.DataStore.setData('leadAdobeDTM', leadData);
};

export const updateOmnitureModalLeadJson = function(modalLeadData){
  MOVE.DataStore.setData('modalAdobeDTM', modalLeadData);
};

export const pageLinking = function () {
  $('#srp-list').find('.js-navigate-to').on('click', function (e) {
    var $this = $(this);

    if ($(e.target).hasClass('js-no-listing-click')) {
      return;
    }

    if ($this.hasClass('js-record-user-activity') && MOVE.SRP) {
      let params = [];
      //LGWEB-ImageCTR
      if (MOVE_DATA.ab_img_ctr_swap.indexOf('V') >= 0)
        params.img_swapped = $this[0] && $this[0].getAttribute('data-is-swapped');
      //end
      if (MOVE.SRP.SearchFacet) {
        var criteria = MOVE.SRP.SearchFacet.getSearchCriteria();
        MOVE.UserActivity.updateRecentSearches({
          searchType: MOVE.Helper.getPropertyStatusForSearch(criteria.search_controller),
          criteria: criteria
        }, true);
      }
      updateListingClickSource($this, params);
    }

    if (!$(e.target).is('a')) {
      // If quickview, we do not want SRP cards to go to LDP on page load
      if ($(e.currentTarget).closest('li').hasClass('js-quick-view')) {
        e.preventDefault();
        return;
      }

      if (e.metaKey || e.ctrlKey) {
        e.preventDefault();
        window.open($this.data('url'), '_blank');
      } else {
        window.location.href = $this.data('url');
      }
    }
  });
};

export const updateListingClickSource = (element, params) => {
  let img_swap;
  if (params)
    img_swap = ':' + params.img_swapped;
  MOVE.UserActivity.updateSrpListingClicked({
    listingRanking: element.data('rank') || element.parent().data('rank'),
    dataSource: MOVE_DATA.adobeDTM.pageType == "ldp-quickview" ? "" : getViewType() + '-card' + img_swap,
    featured: element.data('featured') || element.parent().data('featured')
  });
};

// Get view type either "map" or "list"
export const getViewType = function () {
  let type = $.cookie('ab_srp_viewtype'),
      cookie_arr = [AB_SRP_LAYOUT_COOKIE_MAP, AB_SRP_LAYOUT_COOKIE_LIST, AB_SRP_LAYOUT_COOKIE_MIXED];

  return contains(cookie_arr,type) ? type : AB_SRP_LAYOUT_COOKIE_MIXED;

};

export const getPropertyLinksFromStorage = function () {
  var properties = MOVE.LocalStorage.isAvailable && window.localStorage.getItem('srpProperties');
  if (properties) {
    return JSON.parse(properties);
  }
  return null;
};

export const setPropertyLinksToStorage = function (propertyLinks, totalCount, pageIndex) {
  var properties = getPropertyLinksFromStorage();
  if (!properties) {
    properties = {};
  }
  properties.totalCount = totalCount;
  properties.pageIndex = pageIndex;
  // Saving the unique property links so that crabwalk does not end in
  // infinite loop in case of multi listings.
  properties.links = $.unique(propertyLinks);
  if(MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('srpProperties', JSON.stringify(properties));
  }
};

export const updatePropertyLinksToStorage = function(srpLinks){
  if(MOVE.LocalStorage.isAvailable) {
    var properties = window.localStorage.getItem('srpProperties');
    if (properties) {
      properties = JSON.parse(properties);
      properties.links = _.uniq(properties.links.concat(srpLinks));
    }
    window.localStorage.setItem('srpProperties', JSON.stringify(properties));
  }
};

export const getSearchCriteriaFromCookie = function () {
  var criteriaCookie = $.cookie('criteria');
  if (criteriaCookie) {
    var criterias = {};
    $.each(criteriaCookie.split('&'), function (index, value) {
      var v = value.split('=');
      criterias[v[0]] = v[1];
    });
    return criterias;
  }
};



export const hasSessionStorage = function () {
  try {
    window.sessionStorage.setItem('sessiontest', {});
    window.sessionStorage.removeItem('sessiontest');
    return true;
  } catch (exception) {
    return false;
  }
};

export const isPhone = function () {
  return MOVE.DataStore.getData('isPhone');
};

export const isCln = function () {
  return MOVE.DataStore.getData('isCln');
}

// Check if current search is county search
export const isCountySearch = function isCountySearch(){
  return MOVE.DataStore.getData("locationType") === "county";
};


export const getPropertyStatusForSearch = function (ctrlType) {
  return MOVE.CONSTANTS.PROPERTY_SEARCH_STATUS[ctrlType];
};

export const isRental = function () {
  var currentController = (MOVE.SRP.SearchFacet.getSearchCriteria() || {}).search_controller || '';
  return (currentController === 'Search::ApartmentsController' || currentController === 'Search::HomesForRentController');
};

// returns form field name for validation messaging
export const mapMovingAPIErrorCodeToName = function (code) {
  code = parseInt(code, 10);
  switch (code) {
  case 101:
    return "first-name";
  case 102:
    return "last-name";
  case 201:
    return "email";
  case 202:
  case 203:
  case 208:
  case 210:
  case 212:
    return "phone";
  case 401:
    return "move-from";
  case 501:
    return "move-to";
  default:
    return "unsupported";
  }
};

export const isPrintMode = function() {
  return window.location.pathname.indexOf('/print/') === 0;
};

export const detectViewPort = function () {
  var windowWidth = $(window).width();

  if (windowWidth >= 1280) {
    return 'large';
  }
  else if (windowWidth >= 996) {
    return 'medium';
  }
  else if (windowWidth >= 767) {
    return 'small';
  }
  else if (windowWidth >= 481 && windowWidth <= 766) {
    return 'x-small';
  }
  else if (windowWidth >= 0 && windowWidth <= 480) {
    return 'xx-small';
  }
  else {
    return 'xx-small';
  }
};

export const isInfiniteScrolling = function () {
  return detectViewPort() === 'xx-small' || detectViewPort() === 'x-small';
};

export const isMobile = function () {
  var viewport = detectViewPort();
  return (viewport === 'x-small' || viewport === 'xx-small');
};

export const isLandscapeOrTablet = function () {
  var viewport = detectViewPort();
  var tabletSizes = ['medium', 'large'];
  return _.include(tabletSizes, viewport);
};

export const isMobileDevice = function() {
  return $.Device.isMobile(navigator.userAgent);
};

export const isDesktopOrTablet = negate(isMobileDevice);

//helper for detecting if the device is a Desktop or Tablet, added because the function isDesktopOrTablet() doesn't work for iPads
export const isDesktopTablet = function() {
  return (MOVE.Helper.detectViewPort() === "small" || MOVE.Helper.detectViewPort() === "medium" || MOVE.Helper.detectViewPort() === "large");
};

export const isDebugMode = function (){
  return (window.location.href.search("debug=1") > -1);
};


export const setCookieExpiry = function (minutes) {
  var date = new Date();
  date.setTime(date.getTime() + (minutes * 60000)); // # of ms in 1 minute
  return date;
};

export const getPageNavTarget = function (hsh) {
  return (hsh.length ? hsh : $('[name=' + hsh.slice(1) +']'));
};

export const isPageType = function(pageType) {
  return MOVE.DOMHelper.detectPageType() === pageType;
};

export const isLocationValidated = function (validatedLocation, onPageLoad) {
  return (validatedLocation === undefined && $('#searchBox').val() === '' && !onPageLoad);
};

export const isUrlValidated = function (showIntent) {
  return !(showIntent === true && MOVE.DOMHelper.getUrlParams().pos !== undefined);
};

export const isInvalidCoordinates = function(boundaries) {
  return _.compact(boundaries).length < 4;
};

export const getPropertiesCount = function() {
  return  MOVE.DataStore.getData('searchResults').properties_count;
};

export const isHomePage = function() {
  return MOVE.DOMHelper.detectPageType() === 'hp';
}

let ny_location_flag,
    locationSlugId;

// If Quick View, use property details to build
// location slug.
if (MOVE_DATA.propertyDetails){
  let propertyData = MOVE_DATA.propertyDetails;
  locationSlugId = propertyData.city + "_" + propertyData.state_code;
  locationSlugId = locationSlugId.toLowerCase();
} else {
  locationSlugId = MOVE && MOVE.DataStore ? MOVE.DataStore.getData("slugId") : "";
}

ny_location_flag = (locationSlugId) ? locationSlugId : false;

//New York Experience
export const defaultNyConfigs = {
    ny_exp: MOVE_DATA ? MOVE_DATA.NY_EXP || false : false,
    ny_location: MOVE.DataStore ? ny_location_flag : false,
};

export const getRealTipData = (propertyData) => propertyData && propertyData.real_tip;

export const ctaButtonName = ({propertyType, textType, leadPosition, flags}) => {
  let copy = textType == "request_details" ? "Request Details" : "Contact Agent";
  if((propertyType && propertyType == "new_plan") || (flags && flags.is_spec_home) ) {
    return "Contact Builder";
  } else if(leadPosition === 'inline_cta' && MOVE_DATA.ft_inline_cta_is_enabled) {
    copy = MOVE_DATA.flg_inline_cta ? MOVE_DATA.flg_inline_cta : copy;
  } else if(leadPosition === 'lead_form'  && MOVE_DATA.ft_leadform_cta_is_enabled) {
    copy = MOVE_DATA.flg_leadform_cta ? MOVE_DATA.flg_leadform_cta : copy ;
  }
  return copy;
}

export const formatDate = (date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [month, day, year].join('/');
}

export const getMobileOSType = () => {
  let { platform } = navigator;
  if(platform.indexOf('iP') > -1) return "ios";
  else if(platform.indexOf('Android') > -1) return "android";
  else return "other";
}

MOVE.Helper = {
  pageLinking,
  setPropertyLinksToStorage,
  getPropertyLinksFromStorage,
  getSearchCriteriaFromCookie,
  detectViewPort,
  isInfiniteScrolling,
  hasSessionStorage,
  isPhone,
  isCln,
  updateOmnitureLeadJson,
  updateOmnitureModalLeadJson,
  getPropertyStatusForSearch,
  isRental,
  mapMovingAPIErrorCodeToName,
  isMobile,
  isMobileDevice,
  isLandscapeOrTablet,
  isPrintMode,
  isCountySearch,
  isDebugMode,
  setCookieExpiry,
  getPageNavTarget,
  isPageType,
  isLocationValidated,
  isUrlValidated,
  updatePropertyLinksToStorage,
  isInvalidCoordinates,
  getPropertiesCount,
  defaultNyConfigs,
  updateListingClickSource
};



// WEBPACK FOOTER //
// ./shared_critical/helper.js